// extracted by mini-css-extract-plugin
module.exports = {"gameLinesContainer":"gameLines_gameLinesContainer__Ze60w","gameLines":"gameLines_gameLines__6F3Bp","placeholder":"gameLines_placeholder__cw5J2"};